import { useState } from 'react';
import { useMessages } from './i18n/context';

/**
 * The welcome screen (ADR-027 §7): plan ids are server-generated now, so creating (by name)
 * and opening an existing plan (by id — e.g. pasted from a share or a teammate) are two
 * distinct gestures.
 */
export function OpenPlanForm({
  busy,
  onCreate,
  onOpen,
}: {
  busy: boolean;
  onCreate: (name: string) => void;
  onOpen: (planId: string) => void;
}) {
  const t = useMessages();
  const g = t.grove;
  const [name, setName] = useState('');
  const [planId, setPlanId] = useState('');
  const trimmedName = name.trim();
  const trimmedId = planId.trim();

  return (
    <div className="form-grid">
      <form
        className="card"
        onSubmit={(e) => {
          e.preventDefault();
          if (trimmedName !== '') onCreate(trimmedName);
        }}
      >
        <h2>{t.openPlan.createHeading}</h2>
        <p className="muted">{g.createDescription}</p>
        <label className="field">
          {t.openPlan.nameLabel}
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder={t.openPlan.namePlaceholder}
            disabled={busy}
          />
        </label>
        <button className="button-primary" type="submit" disabled={busy || trimmedName === ''}>
          {t.openPlan.create}
        </button>
      </form>
      <form
        className="card"
        onSubmit={(e) => {
          e.preventDefault();
          if (trimmedId !== '') onOpen(trimmedId);
        }}
      >
        <h2>{t.openPlan.openHeading}</h2>
        <p className="muted">{g.openDescription}</p>
        <label className="field">
          {t.openPlan.idLabel}
          <input
            value={planId}
            onChange={(e) => setPlanId(e.target.value)}
            placeholder={t.openPlan.idPlaceholder}
            disabled={busy}
          />
        </label>
        <button className="button-secondary" type="submit" disabled={busy || trimmedId === ''}>
          {t.openPlan.open}
        </button>
      </form>
    </div>
  );
}
